import theme from "../../theme";

export const appBarStyle = {
  position: "relative",  // ← Use relative instead
  backgroundColor: theme.palette.primary.white,
  color: "black",
  boxShadow: theme.customShadows.medium,
  height: 60,
  pl: 2,
  mb: "2px",
  mt: 0,
  flexDirection: "row",
  alignItems: "center",
  zIndex: theme.zIndex.appBar,
};